import { Injectable, Inject } from '@angular/core';
import { StateInteractionService } from '../../service/dynamic/state.interaction.service';
import { Observable } from 'rxjs';
import {APP_SETTINGS } from '../../../modules/ng-express-engine/tokens'; 
import { DataService } from '../../service/data';
import { Actions, Effect } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import * as fromRoot from '../reducer/core.reducer';
import * as coreActions from '../action/core.actions';

@Injectable()
export class StateRoutingPipe {

    constructor
    (
        @Inject(APP_SETTINGS) private settings: Object,
        private store: Store<fromRoot.State>,
        private actions$: Actions,
        private stateInteraction: StateInteractionService,
        private apiService: DataService,
    ) { 

    }

    private processCmsRoute(route, section: string){
        //console.log(route);
        //console.log(route['navigation']);
        if (route['text']){
          route['name'] = route['text'];
        }
        if (route['children']){
          route['navigation'] = [].concat(route['children']);
        }
        section = (section) ? section : route.name.toUpperCase();
        let rPath = route['path'];
        if (!rPath){
          rPath = route.meta['internal_route'];
        }
        if (!rPath){
          if(route.meta['url'])
          {
            rPath = route.meta['url'];
          }
          else
          {
            rPath = route.meta['details_url'].replace(this.settings['DATA_API_ENDPOINT'],'');
          }
        }
        if(rPath == this.settings['HOME_ROUTE']){
          rPath = '/';
        }
        let rStyle =  (route['render_style']) ? route['render_style'] : route['renderStyle'];
        if (!rStyle && route['meta']){
          rStyle = route.meta['render_style'];
        }

        let rTarget = route['target'];
        if(!rTarget && route['meta'])
        {
          rTarget = route.meta['target'];
        }
        
        
        const internalRoute = {
          selected: false,
          isInternal: true, //logic will follow here when we encounter first the situation,
          inNewWindow: false, //see above
          text: route.name.toUpperCase(),
          section: section.toUpperCase(),
          obj_type: (route['meta']) ? route.meta.obj_type : route.obj_type,
          id: route.id,
          path: rPath,
          target: rTarget,
          renderStyle: rStyle,
          children : this.processCmsRoutes(route['navigation'], true, section)
        };
        //console.log(internalRoute);
        return internalRoute;
    }

    getCmsRoutes(): Observable<any> {
        const data = this.stateInteraction.getStateData('/navigation');
        if (data){
          return Observable.of(data);
        }
        else{
          const cmsRoutesUrl = this.settings['DATA_API_ENDPOINT'] + '/navigation';
          return this.apiService.getData({}, cmsRoutesUrl, 0, false, true, false)
              .map(res => this.processCmsRoutes(res, false, null));
        }
    }
    
    getCmsRoutesFromStore() : Array<Object>{
        return this.processCmsRoutes([].concat(this.stateInteraction.getStateData('/navigation')), false, null);
    }
    
    public processCmsRoutes(routesCopy: Array<object>, isRecursion: boolean, section: string) : Array<Object> {
        //const routesCopy = (isRecursion) ? routes : routes['navigation'];
        if (routesCopy == null ) { return []; }
        if (!Array.isArray(routesCopy)){ 
          return []; 
        }
        else{
          if (routesCopy.length < 1) { return [];  }
        }
        const processedRoutes = routesCopy
          .map((route) => this.processCmsRoute(route, section)); 
        this.store.dispatch(new coreActions.LoadDataItemSuccessAction({ dataContent: processedRoutes, isSlug: true, apiUrl: '/navigation' }));
        return processedRoutes;
    }

    public getRouteMeta(routeUrl: string){
        return this.getCmsRoutesFromStore().find(route => route['path'] == routeUrl);
    }

}


// WEBPACK FOOTER //
// ./src/angular-engine/engine/state/effect/state-routing.pipe.ts